import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { HttpClient } from '@angular/common/http';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ExtratoContaUsuarioService {

  constructor(
    private http: HttpService,
    private httpClient: HttpClient,
  ) { }

  buscaExtratoContaUsuario(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/extrato/contaUsuario', data, successHandle, errorHandle);

  }

  async buscaSaldoContaUsuario(data: any): Promise<any> {
    try {
      const response = await this.httpClient.get<any>(API + '/extrato/saldoContaUsuario', { params: data }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }

  }
  
  buscarProdutoAtivoCnpj(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/products/active/' + data, null, successHandle, errorHandle);
  }

}
